import { css } from "@emotion/react"

const svgFillVariants = (theme, variant) => css({
    '& path': {
        transition: 'fill .25s ease',
        fill: (
            variant === 'outline-light' ||
            variant === 'primary' ||
            variant === 'secondary' ||
            variant === 'dark'
        ) ? 'white' :
        (
            variant === 'outline-primary'
        ) ? theme.colors.primary :
        (
            variant === 'outline-secondary'
        ) ? theme.colors.secondary :
        (
            variant === 'outline-dark'
        ) ? theme.colors.dark :
        'black'
    },
    '&:hover': {
        '& path': {
            fill: (
                variant === 'primary' ||
                variant === 'outline-primary' ||
                variant === 'secondary' ||
                variant === 'outline-secondary' ||
                variant === 'dark' ||
                variant === 'outline-dark'
            ) ? 'white' : 'black'
        },
    }
})

export default svgFillVariants
